import { WireupHandlers } from "./data-wireup";
import { LoadElementAsync, PostJSON } from "./fetchers";

// TODO: At some point, this would be better served with a web component that loads the data via JSON, rather than a flat HTML load

/**
 * Show the participants modal
 * @param {string} modalId ID of the modal element to populate and show
 */
export async function ShowParticipantsModal(modalId, siteAdmin) {
    await LoadElementAsync(modalId, "/trains/" + window.CurrentTrain.Id + "/participants" + (siteAdmin ? "?siteAdmin=true" : ""), true);
    // Wire up the remove buttons
    WireupHandlers("removeparticipant", "click", e => RemoveParticipant(e.currentTarget.dataset["wireupRemoveparticipant"], e.currentTarget));
}

/**
 * Remove the selected participant
 * @param {string} participantId The participant's hashed ID
 * @param {HTMLElement} caller The calling HTMLElement, should be "this"
 */
async function RemoveParticipant(participantId, caller) {
    caller.classList.add("button-loading");
    const row = caller.closest(".participant-row");
    try {
        await PostJSON("/trains/" + window.CurrentTrain.Id + "/participants/" + participantId + "/remove");
        row.remove();
    } catch (err) {
        const errorRow = row.querySelector(".participant-row__error");
        if (err && err.message) {
            errorRow.querySelector(".alert-message").innerText = err.message;
        }
        errorRow.classList.remove("hidden");
    } finally {
        caller.classList.remove("button-loading");
    }
}